module.exports = __webpack_public_path__ + "img/pkg.9ef96ecb.png";